// extracted by mini-css-extract-plugin
export default {"itemError":"ErrorContainer_itemError__VZ9KL","info":"ErrorContainer_info__VUY+v","buttons":"ErrorContainer_buttons__LHYaN"};